import React from 'react';
type CarouselDotsProps = {
  count: number;
  active: number;
  onSelect: (index: number) => void;
  labels: string[];
};
export function CarouselDots({
  count,
  active,
  onSelect,
  labels
}: CarouselDotsProps) {
  return <div className="mt-6 flex justify-center gap-1" aria-label="Choose page" data-id="element-49" data-mp="22u2xzekfbxuo">
      {Array.from({
      length: count
    }, (_, i) => <button key={i} type="button" aria-current={active === i ? 'true' : undefined} aria-label={`Page ${i + 1}: ${labels[i]}`} onClick={() => onSelect(i)} className="flex h-8 w-8 items-center justify-center rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4C5FD5]" data-id="element-50" data-mp="1yq53xi9yhd8h">
          <span className={`block h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${active === i ? 'w-6 bg-[#E8704F]' : 'w-2 bg-[#E6E2DA]'}`} data-id="element-51" data-mp="2hiz5naikj8ur" />
        </button>)}
    </div>;
}